import { Header } from "../../components/my-folders/Header";
import { Cards } from "../../components/my-folders/Cards";

export default function MyFoldersPage() {
  return (
    <div className="w-full h-full p-8">
      <Header />
      <Cards />
    </div>
  );
}
